<template>
    <div class="topTips">
        <img :src="imgUrl + '/APP_RES/home/pinzhiInfo.png'" alt="大方租车 押金双免"/>
        <div class="goHome" @click="goRent">开始租车</div>
    </div>
</template>

<script>
import { imgUrl, orderSource } from "@/utils/env";
export default {
    name: 'topTips',
    data(){
        return {
          imgUrl: imgUrl,
        }
    },
    created () {},
    mounted () {},
    methods: {
        goRent(){
            if(orderSource==16){
                dfpanda.goHome();
            } else {
                window.webkit.messageHandlers.goHome.postMessage(null);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .topTips {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #F6C98E;
        img { width: 100%; }
        .goHome {
            position: absolute;
            left: 50%;
            bottom: 60px;
            transform: translateX(-50%);
            width: 670px;
            height: 120px;
            line-height: 120px;
            text-align: center;
            letter-spacing: 2px;
            color: #8F5200;
            font-size: 33px;
            background-color: #fff;
            box-shadow: 0 0 20px rgba(200,136,51,0.71);
            border-radius: 60px;
        }
    }
</style>